import { useAppSelector } from "stores";

const usePermission = () => {
  const { userProfile, userAppRole } = useAppSelector((state) => state.auth);

  const canAccess = (permission: string) => {
    if (!userProfile) return false;
    return (
      userProfile.isSuperAdmin ||
      userAppRole === "Admin" ||
      userProfile.permissions.some((p) => p === permission)
    );
  };

  return {
    canAccess,
  };
};

export default usePermission;
